export default "__VITE_ASSET__DQLc8iuy__"